import logoSmall from "../../assets/images/logo-small.svg";

const SplashScreen = () => {
    return (
        <div className="splash-screen">
            <div className="splash-screen__logo-letters">
                <span>
                    <img src={logoSmall} alt="Small logo" />
                </span>
                <span>E</span>
                <span>q</span>
                <span>u</span>
                <span>i</span>
                <span>l</span>
                <span>i</span>
                <span>b</span>
                <span>r</span>
                <span>i</span>
                <span>o</span>
            </div>
        </div>
    );
};

export default SplashScreen;
